// extracted by mini-css-extract-plugin
export default {"footer":"IOQGf","footerLeftPart":"VouXX","footerStepsCounterPart":"GkXJ2","footerRightPart":"bLrWf","footerImage":"Cx_ZG"};